import { c as _c } from "react/compiler-runtime";
import { Badge, Box, Button, Card, HStack, Icon, Separator, Text, VStack } from '@chakra-ui/react';
import { useDevicePermissions } from '@src/components/sco/Advisors/hooks/useDevicePermissions';
import { allDevicesReady, DEVICE_KINDS, DEVICE_LABELS, DEVICE_REQUIREMENT_LABELS, DeviceKind, DevicePermissionSnapshot, deviceCheckButtonLabel, deviceStatusLabel, deviceStatusPalette } from '@src/components/sco/Advisors/utils/devicePermissions';
import { ElementType } from 'react';
import { LuCamera, LuMic, LuMonitorUp } from 'react-icons/lu';
const DEVICE_ICONS: Record<DeviceKind, ElementType> = {
  microphone: LuMic,
  camera: LuCamera,
  screen: LuMonitorUp
};
export type SessionDeviceCheckCardProps = {
  devices: Record<DeviceKind, DevicePermissionSnapshot>;
  checking: DeviceKind | null;
  onCheck: (kind: DeviceKind) => void;
};
const DeviceRow = t0 => {
  const $ = _c(45);
  const {
    kind,
    snapshot,
    checking,
    disabled,
    onCheck
  } = t0;
  const IconGlyph = DEVICE_ICONS[kind];
  let t1;
  if ($[0] !== snapshot.status) {
    t1 = deviceStatusPalette(snapshot.status);
    $[0] = snapshot.status;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const palette = t1;
  let t2;
  if ($[2] !== snapshot.status) {
    t2 = deviceCheckButtonLabel(snapshot.status);
    $[2] = snapshot.status;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const actionLabel = t2;
  let t3;
  if ($[4] !== snapshot.status) {
    t3 = deviceStatusLabel(snapshot.status);
    $[4] = snapshot.status;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const statusLabel = t3;
  const name = DEVICE_LABELS[kind];
  const t4 = snapshot.status === "granted" ? "green.fg" : snapshot.status === "denied" || snapshot.status === "error" ? "red.fg" : "colorPalette.fg";
  let t5;
  if ($[6] !== IconGlyph) {
    t5 = <Icon boxSize={4}><IconGlyph /></Icon>;
    $[6] = IconGlyph;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <Box bg="colorPalette.subtle" borderRadius="l2" flexShrink={0} padding={2} color={t4}>{t5}</Box>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== name) {
    t7 = <Text truncate={true} fontSize="sm" fontWeight="medium">{name}</Text>;
    $[11] = name;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = DEVICE_REQUIREMENT_LABELS[kind];
  let t9;
  if ($[13] !== t8) {
    t9 = <Text color="colorPalette.fg/50" fontSize="xs">{t8}</Text>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t9) {
    t10 = <HStack gap={2}>{t7}{t9}</HStack>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== name) {
    t11 = name.toLowerCase();
    $[18] = name;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = `${actionLabel} ${t11}`;
  let t13;
  if ($[20] !== kind || $[21] !== onCheck) {
    t13 = () => onCheck(kind);
    $[20] = kind;
    $[21] = onCheck;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== actionLabel || $[24] !== checking || $[25] !== disabled || $[26] !== t12 || $[27] !== t13) {
    t14 = <Button aria-label={t12} disabled={disabled} flexShrink={0} loading={checking} size="sm" variant="outline" onClick={t13}>{actionLabel}</Button>;
    $[23] = actionLabel;
    $[24] = checking;
    $[25] = disabled;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t10 || $[30] !== t14) {
    t15 = <HStack align="center" gap={2} justify="space-between">{t10}{t14}</HStack>;
    $[29] = t10;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  const t16 = snapshot.status === "granted" || snapshot.status === "denied" || snapshot.status === "error" ? "subtle" : "outline";
  let t17;
  if ($[32] !== palette || $[33] !== statusLabel || $[34] !== t16) {
    t17 = <HStack gap={2} wrap="wrap"><Badge aria-live="polite" colorPalette={palette} size="sm" variant={t16}>{statusLabel}</Badge></HStack>;
    $[32] = palette;
    $[33] = statusLabel;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== snapshot.detail) {
    t18 = snapshot.detail && <Text color="colorPalette.fg/60" fontFamily="longform" fontSize="xs">{snapshot.detail}</Text>;
    $[36] = snapshot.detail;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t15 || $[39] !== t17 || $[40] !== t18) {
    t19 = <VStack align="stretch" flex="1" gap={0} minWidth={0}>{t15}{t17}{t18}</VStack>;
    $[38] = t15;
    $[39] = t17;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t19 || $[43] !== t6) {
    t20 = <HStack align="flex-start" gap={3}>{t6}{t19}</HStack>;
    $[42] = t19;
    $[43] = t6;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  return t20;
};
export const SessionDeviceCheckCard = t0 => {
  const $ = _c(19);
  const {
    devices,
    checking,
    onCheck
  } = t0;
  let t1;
  if ($[0] !== devices) {
    t1 = allDevicesReady(devices);
    $[0] = devices;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const ready = t1;
  const busy = checking !== null;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text color="colorPalette.fg/55" textStyle="labelXs">Check your settings</Text>;
    t3 = <Text color="colorPalette.fg/60" fontFamily="longform" fontSize="sm">This is an on-site video call in your browser — no Zoom or Meet. Check camera, microphone, and screen share now so joining isn’t interrupted by permission prompts.</Text>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== ready) {
    t4 = ready && <Text color="green.fg" fontFamily="longform" fontSize="sm" fontWeight="medium">You’re set. Joining shouldn’t be interrupted by permission prompts.</Text>;
    $[4] = ready;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <VStack align="stretch" gap={1}>{t2}{t3}{t4}</VStack>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== busy || $[9] !== checking || $[10] !== devices || $[11] !== onCheck) {
    t6 = DEVICE_KINDS.map((kind, index) => <Box key={kind} as="li">{index > 0 && <Separator marginBottom={3} />}<DeviceRow checking={checking === kind} disabled={busy} kind={kind} snapshot={devices[kind]} onCheck={onCheck} /></Box>);
    $[8] = busy;
    $[9] = checking;
    $[10] = devices;
    $[11] = onCheck;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <VStack align="stretch" as="ul" gap={3} listStyleType="none" margin={0} padding={0}>{t6}</VStack>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text color="colorPalette.fg/50" fontFamily="longform" fontSize="xs">Screen share can’t stay authorized. Checking confirms this browser can share; you’ll still pick a window during the call.</Text>;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t5 || $[17] !== t7) {
    t9 = <Card.Root boxShadow="sm" variant="subtle"><Card.Body gap={4}>{t5}{t7}{t8}</Card.Body></Card.Root>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
export const SessionDeviceCheck = () => {
  const $ = _c(6);
  const {
    devices,
    checking,
    check
  } = useDevicePermissions();
  let t0;
  if ($[0] !== check) {
    t0 = kind => {
      check(kind);
    };
    $[0] = check;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== checking || $[3] !== devices || $[4] !== t0) {
    t1 = <SessionDeviceCheckCard checking={checking} devices={devices} onCheck={t0} />;
    $[2] = checking;
    $[3] = devices;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};